<breadcrumb-navigation [titles]="[{ key: 'MY_ACCOUNT', url: ''}]"></breadcrumb-navigation>

<div class="my-account__container">
  <div class="my-account__module mx:py-4 sm:py-4">
    <div class="subtitle">{{ "ACCOUNT_BASIC_INFOMATION" | translate }}</div>
    <div class="my-account__info sm:block sm:text-center mx:flex">
      <div 
        class="my-account__info-avatar" 
        *ngIf="userData?.queryUserPageInfoResDTO?.name"
      >
      {{ userData?.queryUserPageInfoResDTO?.lastName?.substring(0, 1) }}{{ userData?.queryUserPageInfoResDTO?.firstName?.substring(0, 1) }}
      </div>
      <div class="my-account__info-list sm:pl-0 mx:pl-8">
        <div class="my-account__info-item sm:block mx:flex">
          <span class="label sm:pr-0 mx:pr-4">{{userData?.queryUserPageInfoResDTO?.name}}</span>
          <div>
            <span class="role-tag">{{ userData?.queryUserPageInfoResDTO?.category || '--' }}</span>
          </div>
         
        </div>
        <div class="text-left">
          <div class="my-account__info-item">
            <span  class="label sm:block mx:pr-4">{{ "EMAIL" | translate }}</span>
            <span>{{ userData?.queryUserPageInfoResDTO?.email ?? "--" }}</span>
            <p class="tip" *ngIf="isDealerPortal">
              {{ "CHANGE_EMAIL_LABEL" | translate }}
              <span class="link" (click)="handleChangeEmail()">SingleKey ID</span>
            </p>
          </div>
          <div class="my-account__info-item" *ngIf="isDealerPortal">
            <span  class="label sm:block mx:pr-4">{{ "MOBILE_PHONE_NUMBER" | translate }}</span>
            <span>{{ userData?.queryUserPageInfoResDTO?.phoneNumber ?? "--" }}</span>
            <p class="tip">
              {{ "CHANGE_PHONE_NUMBER_LABEL" | translate }}
              <span class="link"  (click)="handleChangePhoneNo()">SingleKey ID</span>
            </p>
          </div>
          <div class="my-account__info-item" *ngIf="isDealerPortal">
            <span  class="label sm:block">{{ "PASSWORD" | translate }}</span>
            <p class="tip">
              {{ "CHANGE_PASSWORD_LABEL" | translate }}
              <span class="link"  (click)="handleChangePassword()">SingleKey ID</span>
            </p>
          </div>
          <div class="my-account__info-item" *ngIf="isDealerPortal">
            <span  class="label">{{ "CLOSE_ACCOUNT_LABEL" | translate }}</span>
            <p class="tip no-required">
              {{ "CLOSE_ACCOUNT_TIP" | translate }}
              <span class="link"  (click)="handleDeleteAccount()">{{ "HERE_LINK" | translate }}.</span>
            </p>
            <p class="tip no-required">{{ "CLOSE_ACCOUNT_TIP1" | translate }}</p>
            <p class="tip no-required">
              {{ "CLOSE_ACCOUNT_TIP2" | translate }}
              <span class="link"  (click)="handleDeleteAccount()">SingleKey ID.</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="my-account__module mx:p-4 sm:px-4">
    <div class="subtitle">{{ "ACCOUNT_ORGANIZATION_INFORMATION" | translate }}</div>
    <div class="my-account__organization" *ngIf="isDealerPortal">
      <div class="my-account__organization-title">
        <svg-icon [iconName]="'my-info.svg'" class="mr-2.5" [size]="48"></svg-icon>
        <span class="">{{ "CH3" | translate }}</span>
      </div>
      <div class="my-account__organization-content sm:block mx:flex mx:px-14">
        <div class="info-item">
          <span class="label">{{ "CH3_CODE" | translate }}</span>
          <span class="value">{{ ch3Data.ch3Code || '--'}}</span>
        </div>
        <div class="info-item">
          <span class="label">{{ "CH3_NAME" | translate }}</span>
          <span class="value">{{ ch3Data.ch3Name || '--'}}</span>
        </div>
      </div>
    </div>

    <div class="my-account__organization">
      <div class="my-account__organization-title">
        <svg-icon [iconName]="'my-info.svg'" class="mr-2.5" [size]="48"></svg-icon>
        <span class="">{{ "SOLD_TO" | translate }}</span>
      </div>
      <div class="my-account__organization-content sm:p-0">
        <nz-table 
          class="e-shop-table" 
          style="width: 100%; overflow-x: auto;"
          [nzData]="soldtoList" 
          #fixedTable 
          [nzSize]="'small'"
          [nzScroll]="{ x: '1000px' }"
          [nzWidthConfig]="['150px','200px','150px','150px','150px','200px','180px','200px','120px']"
          [nzFrontPagination]="false" 
          [nzResponsive]="true" 
          [nzTotal]="pagination.total"
          [nzPageIndex]="pagination.pageIndex"
          [nzPageSize]="pagination.pageSize"
          (nzPageIndexChange)="pageIndexChange($event)"
         >
          <thead>
            <tr>
              <th *ngFor="let col of columns; let last = last" [nzRight]="last ? '0px' : false">
                {{ col.name }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let data of soldtoList;">
              <td>{{ data.customerCode }}</td>
              <td>{{ data.customerName }}</td>
              <td>{{ data.ch3 }}</td>
              <td>{{ data.salesOrganization }}_{{ data.distributionChannel }}_{{ data.division }}</td>
              <!-- <td>{{ data.defaultShipCode }}</td>
              <td>{{ data.defaultShipName }}</td> -->
              <td>{{ data.defaultPayerCode }}</td>
              <td>{{ data.defaultPayerName }}</td>
              <td>{{ data.defaultBillCode }}</td>
              <td>{{ data.defaultBillName }}</td>
              <!-- <td>{{ data.salesEmployeeCode }}</td> -->
              <td nzRight="0px">
                <span class="link" (click)="navigateToDetail(data)">{{ "VIEW_DETAIL" | translate }}</span>
              </td>
            </tr>
          </tbody>
        </nz-table>
      </div>
    </div>
  </div>
</div>

  




